import React from 'react';
import Button from '../Button.js';
import { Flex, Box } from 'rebass';
import Styled from 'styled-components';
import { Headline } from '../../FontStyles';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

const StepContainer = Styled(Flex)`

align-items: center;
justify-content: space-between;

`;

export const StickyButtonFooter = Styled(Flex)`
position: fixed;
bottom: 0;
left: 0;
z-index: 14;
min-height: 80px;
width: 100%;
border-top: ${props => props.theme.border};
background-color: #fff;
`;

export default props => (
  <div>
    {props.currentStepNumber === props.stepNumber && (
      <Flex width={1} justifyContent="center" alignItems="center" flexWrap="wrap">
        <StepContainer width={props.large ? 0.9 : 0.5} flexWrap="wrap" py={2}>
          <Flex width={1} flexWrap="wrap" textAlign="left" px={4}>
            <Headline mb={5}> {props.prompt ? props.prompt : ''}</Headline>
            <Flex width={1} mb={6}>
              {props.children}
            </Flex>
          </Flex>
        </StepContainer>
        <StickyButtonFooter width={1} justifyContent="center" alignItems="center">
          <Flex width={1} px={4} maxWidth={1280} justifyContent="center">
            <Flex width={1} maxWidth={1280} justifyContent="space-between" px={5} alignItems="center">
              {props.currentStepNumber > 0 || props.values.activeSection > 0 ? (
                <Button
                  disabled
                  className="large"
                  onClick={() => {
                    props.currentStepNumber > 0
                      ? props.setCurrentStepNumber(props.currentStepNumber - 1)
                      : props.setFieldValue('activeSection', props.values.activeSection - 1);
                  }}
                >
                  <Flex justifyContent="center" alignItems="center">
                    <Flex pt="2px">
                      <ChevronLeftIcon
                        font-size="inherit"
                        style={{ paddingTop: '2px', fontSize: '24px', maxHeight: '16px' }}
                      />
                    </Flex>
                    {`Previous step`}
                  </Flex>
                </Button>
              ) : (
                <Flex width={0.5} />
              )}
              <Button
                disabled
                className="large"
                height="40px"
                onClick={() => {
                  !props.finalStep
                    ? props.setCurrentStepNumber(props.currentStepNumber + 1)
                    : props.setFieldValue('activeSection', props.values.activeSection + 1);
                }}
              >
                <Flex justifyContent="center" alignItems="center">
                  {`Save and continue `}
                  <Flex pt="2px">
                    <ChevronRightIcon
                      font-size="inherit"
                      style={{ paddingTop: '2px', fontSize: '24px', maxHeight: '16px' }}
                    />
                  </Flex>
                </Flex>
              </Button>
            </Flex>
          </Flex>
        </StickyButtonFooter>
      </Flex>
    )}
  </div>
);
